import listViewStore from 'owa-mail-list-store/lib/store/Store';
import ConversationItem from '../store/schema/ConversationItem';

export default function selectConversationById(conversationId: string): ConversationItem {
    return listViewStore.conversationItems.get(conversationId);
}
